import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { DeleteButton } from '#component/project/form/custom-fields/custom-field-item/styles';

/**
 * Renders MUI Icon button to remove deleteCustomFieldItem setting.
 * @returns {React.FC}
 */

const CustomFieldItemActions = ({ deleteCustomFieldItem, tooltipTitle }) => (
  <DeleteButton
    size="small"
    onClick={deleteCustomFieldItem}
    aria-label="Delete custom field"
  >
    <Tooltip title={tooltipTitle}>
      <DeleteIcon />
    </Tooltip>
  </DeleteButton>
);

export default CustomFieldItemActions;
